<template>
  <div>
    <v-card class="mx-auto">
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Utilisateurs Online
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card flat class="mx-4 py-4">
        <v-card-title> Utilisateurs en ligne</v-card-title>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Recherche"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="UsersOnline"
          class="elevation-0"
          :search="search"
          id="printSection"
        >
          <template v-slot:item.status="{ item }">
            <v-chip class="ma-2" color="green" text-color="white">
              Online
            </v-chip>
          </template>
          <template v-slot:item.dateLastConnexion="{ item }">
            {{ dateProcess(item.dateLastConnexion) }}
          </template>
          <template v-slot:item.dateDeConnexion="{ item }">
            {{ dateProcess(item.dateDeConnexion) }}
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { deviceDetect } from "mobile-device-detect";
export default {
  created() {
    this.GetUsersOnline();
  },
  data() {
    return {
      UsersOnline: [],
      search: "",
      device: deviceDetect(),
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Nom",
          align: "start",
          value: "displayName",
        },
        {
          text: "Statut",
          align: "left",
          value: "status",
        },
        {
          text: "Dernière Connexion",
          align: "left",
          value: "dateLastConnexion",
        },
        {
          text: "Dernière Déconnexion",
          align: "left",
          value: "dateDeConnexion",
        },
        /* {
          text: "OS",
          align: "left",
          value: "osName",
        },
        {
          text: "Browser",
          align: "left",
          value: "browserName",
        }, */
      ];
    },
  },
  methods: {
    dateProcess(date) {
      var dateProcessed = this.$moment(date).format("DD-MM-YYYY HH:mm:ss");

      return dateProcessed;
    },

    GetUsersOnline() {
      let self = this;
      this.$firebase
        .firestore()
        .collection("users")
        .where("status", "==", "online")
        .orderBy("dateLastConnexion")
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.UsersOnline.push({
                ...doc.data(),
                id: doc.id,
              });
            });
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped></style>
